import React, {PureComponent} from "react";
import {connect} from "react-redux";
import {Modal, ModalBody, ModalHeader, ModalFooter} from "reactstrap";
import Button from "../Button";
import {hideModal} from "./reducer/ModalActions";
import SmsForm from "./SmsForm";
import {withTranslation} from "react-i18next";

class SmsModalContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.formRef = React.createRef();

    this.state = {
      saving: false,
    };
  }

  setSaving = (saving) => {
    this.setState({
      saving,
    });
  }

  toggleModal = () => {
    this.setSaving(false);

    this.props.hideModal();
  }

  save = () => {
    // this.setSaving(true);
    this.formRef.current.save();
  }

  render() {
    const {saving} = this.state;

    return <Modal isOpen={this.props.modal.isOpen} size="lg">
      <ModalHeader toggle={this.toggleModal}>{this.props.t('header')}</ModalHeader>
      <ModalBody>
        {this.props.modal.isOpen && <div>
          <SmsForm
            ref={this.formRef}
            clientSelectDisabled={this.props.modal.clientSelectDisabled}
            data={this.props.modal.data}
            onSavingEnd={() => this.setSaving(false)}
            onSavingSuccess={() => {
              if(this.props?.modal?.onSent){
                this.props.modal.onSent()
              }
              this.toggleModal()
            }}
          />
        </div>}
      </ModalBody>
      <ModalFooter className="d-flex justify-content-between">
        <Button color="secondary" onClick={this.toggleModal}>{this.props.t('button_cancel')}</Button>

        <Button
          loading={saving}
          color="success"
          onClick={this.save}
        ><i className="fas fa-send"/><span>{this.props.t('button_send')}</span></Button>
      </ModalFooter>
    </Modal>
  }
}

function mapStateToProps(state) {
  return {
    modal: state.smsModalContainer
  }
}

export default connect(mapStateToProps, {hideModal})(withTranslation('sms_modal_container')(SmsModalContainer));
